.icon {
    path {
        fill: currentColor;
    }
}
